import axios from '../../utilities/axios';
import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';
import { primaryAPI } from '../../utilities/apiEndpointUtility';

import {
	requestKitShipment,
	requestKitShipmentCompleted,
	requestKitShipmentFailed
} from './requestKitShipmentSlice';
import { handleAxiosError } from '../../utilities/errorUtility';

const requestKitShipmentEpic = (action$) =>
	action$.pipe(
		ofType(requestKitShipment),
		mergeMap(async (action) => {
			try {
				const kitShipmentRequest = action.payload;
				const response = await axios.post(
					`${primaryAPI()}/kit-shipment/validate-subscriber`,
					kitShipmentRequest
				);
				return {
					request: kitShipmentRequest,
					response: response?.data
				};
			} catch (error) {
				handleAxiosError(error?.response?.status);
			}
		}),
		switchMap((res) => [requestKitShipmentCompleted(res)]),
		catchError((error, source) =>
			merge(of(requestKitShipmentFailed(error.message)), source)
		)
	);

export default [requestKitShipmentEpic];
